import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import CardFooter from '../components/CardFooter.js';
import CardContent from '../components/CardContent.js';
import Card from '../Card.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["columnSpan", "image", "lazy", "externalImage", "title", "subtitle", "description", "bullets", "ksps", "price", "originalPrice", "pricePerPerson", "originalPricePerPerson", "buttonDisabled", "buttonText", "buttonVariant", "linkList", "additionalCardContent", "url", "onClick", "hideImage"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var RoomCard = function RoomCard(_ref) {
  var _ref$columnSpan = _ref.columnSpan,
    columnSpan = _ref$columnSpan === void 0 ? 4 : _ref$columnSpan,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? null : _ref$image,
    _ref$lazy = _ref.lazy,
    lazy = _ref$lazy === void 0 ? false : _ref$lazy,
    _ref$externalImage = _ref.externalImage,
    externalImage = _ref$externalImage === void 0 ? null : _ref$externalImage,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? null : _ref$subtitle,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? null : _ref$description,
    _ref$bullets = _ref.bullets,
    bullets = _ref$bullets === void 0 ? null : _ref$bullets,
    _ref$ksps = _ref.ksps,
    ksps = _ref$ksps === void 0 ? null : _ref$ksps,
    _ref$price = _ref.price,
    price = _ref$price === void 0 ? null : _ref$price,
    _ref$originalPrice = _ref.originalPrice,
    originalPrice = _ref$originalPrice === void 0 ? null : _ref$originalPrice,
    _ref$pricePerPerson = _ref.pricePerPerson,
    pricePerPerson = _ref$pricePerPerson === void 0 ? null : _ref$pricePerPerson,
    _ref$originalPricePer = _ref.originalPricePerPerson,
    originalPricePerPerson = _ref$originalPricePer === void 0 ? null : _ref$originalPricePer,
    _ref$buttonDisabled = _ref.buttonDisabled,
    buttonDisabled = _ref$buttonDisabled === void 0 ? false : _ref$buttonDisabled,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? null : _ref$buttonText,
    _ref$buttonVariant = _ref.buttonVariant,
    buttonVariant = _ref$buttonVariant === void 0 ? 'tertiary' : _ref$buttonVariant,
    _ref$linkList = _ref.linkList,
    linkList = _ref$linkList === void 0 ? null : _ref$linkList,
    _ref$additionalCardCo = _ref.additionalCardContent,
    additionalCardContent = _ref$additionalCardCo === void 0 ? null : _ref$additionalCardCo,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? null : _ref$url,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$hideImage = _ref.hideImage,
    hideImage = _ref$hideImage === void 0 ? false : _ref$hideImage,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsxs(Card, _objectSpread(_objectSpread({}, rest), {}, {
    columnSpan: columnSpan,
    imagePosition: "top",
    image: image,
    lazy: lazy,
    externalImage: externalImage,
    url: url,
    variant: "room",
    onClick: onClick,
    hideImage: hideImage,
    children: [/*#__PURE__*/jsx(CardContent, {
      title: title,
      subtitle: subtitle,
      bullets: bullets,
      ksps: ksps,
      description: description,
      linkList: linkList,
      children: additionalCardContent
    }), /*#__PURE__*/jsx(CardFooter, {
      price: price,
      originalPricePerPerson: originalPricePerPerson,
      originalPrice: originalPrice,
      pricePerPerson: pricePerPerson !== null ? Number(pricePerPerson) : null,
      discountDisplayType: "hide",
      buttonText: buttonText,
      buttonUrl: url,
      buttonVariant: buttonVariant,
      buttonDisabled: buttonDisabled
    })]
  }));
};
var RoomCard$1 = RoomCard;

export { RoomCard$1 as default };
//# sourceMappingURL=RoomCard.js.map
